// Canvas Assignment Review actions
export const CANVAS_APP_LOAD_REVIEW_PAGE = 'CANVAS_APP_LOAD_REVIEW_PAGE';
export const CANVAS_APP_LOAD_REVIEW_PAGE_SUCCESS = 'CANVAS_APP_LOAD_REVIEW_PAGE_SUCCESS';
export const CANVAS_APP_LOAD_REVIEW_PAGE_FAILED = 'CANVAS_APP_LOAD_REVIEW_PAGE_FAILED';
export const CANVAS_APP_LOAD_STUDENT_SUCCESS = 'CANVAS_APP_LOAD_STUDENT_SUCCESS';
export const CANVAS_APP_LOAD_ASSIGNMENTS_REQUEST = 'CANVAS_APP_LOAD_ASSIGNMENTS_REQUEST';
export const CANVAS_APP_LOAD_ASSIGNMENTS_SUCCESS = 'CANVAS_APP_LOAD_ASSIGNMENTS_SUCCESS';
export const CANVAS_APP_LOAD_ASSIGNMENTS_FAILURE = 'CANVAS_APP_LOAD_ASSIGNMENTS_FAILURE';
export const CANVAS_APP_LOAD_ARTICLE_HEADER_SUCCESS = 'CANVAS_APP_LOAD_ARTICLE_HEADER_SUCCESS';
export const CANVAS_APP_LOAD_ARTICLE_WORDS_SUCCESS = 'CANVAS_APP_LOAD_ARTICLE_WORDS_SUCCESS';
export const CANVAS_APP_LOAD_STUDENT_QUIZZ_SUCCESS = 'CANVAS_APP_LOAD_STUDENT_QUIZZ_SUCCESS';
export const CANVAS_APP_LOAD_ANNOTATIONS_SUCCESS = 'CANVAS_APP_LOAD_ANNOTATIONS_SUCCESS';
